import React from 'react';
import { Shield, Lock, Zap, Globe } from 'lucide-react';
export function Header() {
  return <div className="w-full bg-gold-dark text-black py-2 px-4 text-sm font-medium" data-id="element-139">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-center" data-id="element-140">
        <span className="flex items-center gap-1" data-id="element-141">
          <Shield size={14} data-id="element-142" /> 7-day guarantee
        </span>
        <span className="hidden sm:inline" data-id="element-143">•</span>
        <span className="flex items-center gap-1" data-id="element-144">
          <Lock size={14} data-id="element-145" /> Secure payment
        </span>
        <span className="hidden sm:inline" data-id="element-146">•</span>
        <span className="flex items-center gap-1" data-id="element-147">
          <Zap size={14} data-id="element-148" /> Immediate access
        </span>
        <span className="hidden sm:inline" data-id="element-149">•</span>
        <span className="flex items-center gap-1" data-id="element-150">
          <Globe size={14} data-id="element-151" /> Pay in your local currency
        </span>
      </div>
    </div>;
}